import {
  isTripPayment,
  type FlightPaymentParams,
  type HotelPaymentParams,
  type StandardInitiatePaymentParams,
  type TripPaymentParams,
} from "@/app/payments/types";

type OrderApiParams =
  | {
      apiUrl: "/orders";
      apiParams: FlightPaymentParams | HotelPaymentParams;
    }
  | {
      apiUrl: "/orders/package";
      apiParams: TripPaymentParams;
    };

export const constructOrderApiParams = (
  params: StandardInitiatePaymentParams,
): OrderApiParams => {
  if (isTripPayment(params)) {
    const { serviceType, ...apiParams } = params;
    return { apiUrl: "/orders/package", apiParams };
  }

  const { availabilityTokens, promoCode } = params;
  return { apiUrl: "/orders", apiParams: { availabilityTokens, promoCode } };
};
